import React, { useCallback, useContext, useMemo } from "react";
import _ from 'lodash'
import { TranslatorContext } from "@jutro/locale";
import { ViewModelForm, ViewModelServiceContext } from "@xengage/gw-portals-viewmodel-react";
import metadata from './TWIAViewLocation.metadata.json5'
import styles from './TWIAViewLocation.module.scss'
import messages from './TWIAViewLocation.messages.js'
import { Link } from '@jutro/router';

function TWIAViewLocation({location, building, addBuildingFromLocationLink, backAction, handleBuildingLink, handleEditLinkClick}) {
    console.log(location)
    const translator = useContext(TranslatorContext)
    const viewModelService = useContext(ViewModelServiceContext);

    const renderClassCodeCell = (building) => building.classCode ? building.classCode.code +': ' + building.classCode.classification : '-'

    const renderCoverageFormCell = (building) => translator({id: viewModelService.productMetadata.get('pc').types.getTypelist('CoverageForm').getCode(building.coverageForm).name});
    
    const renderDescriptionCell = (building) => {
        return (
            <div style={{whiteSpace: 'break-spaces'}}>
                <Link onClick={() => handleBuildingLink(building)}>{building.description}</Link>
            </div>
        )
    }

    const editLocation = useCallback(() => {
        handleEditLinkClick(0, false, false, true, building);
    }, [handleEditLinkClick])

    const getBuildingsFromLocation = useMemo(() => {
        const address = location.displayName;
        return location.buildings.map(building => ({
            ...building,
            description: building.description || building.name,
            location,
            address: address,
        }))
    }, [])
    

    const overrideProps = {
        locationTitle: {
            content: location.displayName
        },
        buildingListTitle: {
            content: translator(messages.buildingListTitle, {buildingLength: location.buildings.length})
        },
        buildingDataTable: {
            data: getBuildingsFromLocation
        },
        buildingListBuildingButton: {
            visible: building?.coverageForm !== 'TWCR'
        }
    }

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            backAction,
            renderClassCodeCell,
            renderCoverageFormCell,
            renderDescriptionCell,
            addBuildingFromLocationLink,
            editLocation
        }
    }

    return (
        <ViewModelForm
                uiProps={metadata.pageContent}
                model={location}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
    )
}

export default TWIAViewLocation